import styled from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const DateContent = styled.p`
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    padding-bottom: 2rem;

    ${FONT_PROPERTIES}

    ${mediaMaxWidth.medium`
        flex-direction: column;
        gap: 0;
        padding-bottom: 1.5rem;
    `}

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
